import {
  GET_SERVICES_DETAILS_REQUEST,
  GET_SERVICES_DETAILS_SUCCESS,
  GET_SERVICES_DETAILS_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { autoAllocateDate, autoAllocateOrgUnitId } from '../../../reducers/areas/dailyPlanning/selectors';
import { queryStringBuilder } from '../../../utils/helpers';

export function getServicesDetails() {
  return {
    types: [GET_SERVICES_DETAILS_REQUEST, GET_SERVICES_DETAILS_SUCCESS, GET_SERVICES_DETAILS_FAILURE],

    buildCallParameters: state => {
      const parameters = {
        selectedDate: autoAllocateDate(state),
        orgUnitId: autoAllocateOrgUnitId(state),
      };
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetServicesDetails${queryStringBuilder(parameters)}`,
      };
    },
  };
}
